<template>
    <header class="head-top">
        <div class="loginRight">
            <p class="main-container">
                <span class="linkspan register">Hi，{{ companyName }} </span>
                <span class="linkspan line"></span>
                <span class="linkspan backIndex" @click="toFirstIndex">回到首页</span>
                <span class="linkspan line"></span>
                <span class="linkspan helpT" @click="toHelp">帮助中心</span>
                <span class="linkspan line"></span>
                <span class="linkspan standardT" @click="toStandard">供应商入库标准</span>
               <!-- <span class="linkspan line"></span>
                <el-popover
                    placement="bottom"
                    width="260"
                    trigger="hover">
                    <img src="../../assets/images/masterCenter/topBar/QRCode.jpg" >
                    <span slot="reference" class="linkspan wechatT">微信服务号</span>
                </el-popover>-->
                <span class="linkspan line"></span>
                <span class="linkspan loginOut" @click="toLoginOut">退出</span>
            </p>
        </div>
        <div class="main-container">
            <img class="logoImg" @click="toFirstIndex" src="../../assets/images/topBar1/logoIcon.png"/>
            <el-menu :default-active="$root.activeIndex" ref="menus" :activeIndex="$root.activeIndex" class="head-menu" mode="horizontal" @select="$root.handleSelect">
                <el-menu-item index="home" @click="toFirst">管理中心</el-menu-item>
                <el-menu-item index="invite" @click="toSecond">基本信息</el-menu-item>
                <el-menu-item index="win" @click="toThird">投标管理</el-menu-item>            </el-menu>
        </div>
    </header>
</template>

<script type="text/babel">
    import Vue from 'vue'
    export default Vue.component('master-header',{
        data () {
            return {
                isLogin:  window.sessionStorage.getItem('refresh_token') ? true : false,
                companyName: window.sessionStorage.getItem('companyName'),
                isMaster: window.sessionStorage.getItem('isMaster')
            }
        },
        methods: {
            toFirstIndex(){
                this.$router.push('/');
                this.$root.activeIndex = 'home';
            },
            toLoginOut(){                window.sessionStorage.clear();                this.$router.push('/login/masterCenter');
                this.$root.isLogin = false;
            },
            toFirst(){
                this.$root.activeIndex = 'home';
                this.$router.push('/master/center');
            },
            toSecond(){
                this.$root.activeIndex = 'invite';
                this.$router.push( '/master/basicInfo/1');
            },
            toThird(){
                this.$root.activeIndex = 'win';
                this.$router.push('/master/inviteManagement');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            toStandard(){
                this.$router.push( '/supplierAddStandard');
            },
        },
        mounted(){
//            this.$root.activeIndex = 'home';
            this.isMaster = window.sessionStorage.getItem('isMaster');
        }
    })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/_var.scss';
    .el-breadcrumb {
        height: 44px;
        line-height: 44px;
    }
    .head-top {
        /*position: absolute;*/
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        height: 80px;
        /*background: rgba(255,255,255,1);*/
        background: rgba(255,255,255,0);
        transition: .5s;
        & .line {
            width: 1px;
            height: 12px;
            background: #fff;
        }
        & .loginRight {
            border-bottom: 1px solid $--secondary-fill-color;
            p {
                text-align: right;
                font-size: 12px;
                color: $--text-color-light;
                line-height: 20px;
                span {
                    display: inline-block;
                    vertical-align: middle;
                }
                .linkspan:nth-of-type(odd) {
                    padding-left: 35px;
                    padding-right: 14px;
                    cursor: pointer;
                }
                .register {
                    background: url('../../assets/images/topBar2/icon08.png') no-repeat 10px center;
                    padding-left: 26px;
                }
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon02.png') no-repeat 10px center;
                }
                .standardT {
                    background: url('../../assets/images/topBar1/standard2.png') no-repeat 10px center / 16px 16px;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon04.png') no-repeat 10px center;
                }
                .line {
                    background: $--text-color-light;
                }
            }
        }
       /* & .loginIndex {
            border-bottom: 1px solid #fff;
            p {
                color: #fff;
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
                }
                .standardT {
                    background: url('../../assets/images/topBar1/standard.png') no-repeat 10px center / 16px 16px;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
                }
                .line {
                    background: #fff;
                }
            }
        }*/
    }
    .head-top-white {//头部背景为白色
        background: rgba(255,255,255,1);
    }
    .head-top .main-container {
        background: none;
        overflow: hidden;
    }
    .logoImg {
        float: left;
        vertical-align: middle;
        margin: 15px 120px 0 0;
        width: 240px;
        height: 30px;
        cursor: pointer;
    }
    .el-menu {
        float: left;
        vertical-align: middle;
        border: none;
        background: none;
    }
    .head-right {
        margin-top: 16px;
        float: right;
        vertical-align: middle;
        color: #fff;
        font-size: 12px;
    }
    .head-right span {
        display: inline-block;
        margin: 0 2px;
        vertical-align: middle;
        cursor: pointer;
    }
    .head-right .help {
        margin-left: 20px;
        width: 28px;
        height: 28px;
         background: url('../../assets/images/topBar1/icon01.png') no-repeat;
     }
    .wechat {
        width: 28px;
        height: 28px;
        background: url('../../assets/images/topBar1/icon02.png') no-repeat;
    }
    .el-menu--horizontal > .el-menu-item {
        color: $--text-color;
        height: 58px;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
        font-weight: 700;
        color: $--text-color;
        background: none;
     }
    .el-menu--horizontal .el-menu-item:hover, .el-menu--horizontal .el-menu-item:focus {
        color: $--text-color;
        background: none;
    }
    .head-top-bg {
        position: fixed;
        /*height: 60px;*/
        background: #fff;
        /*background: rgba(255, 255, 255, .8);*/
        & .head-right {
            color: $--text-color-light;
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
        background: none;
        /*color: #fff;*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/MasterHeader.vue